/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import auth from '@/auth/authService'
import store from '@/store/store'
import LoginService from '@/services/api/LoginService'
import UserService from '@/services/api/UserService'
import TwoFactorService from '@/services/api/TwoFactorService'
import NotificationService from '@/services/api/NotificationService'
import Vue from 'vue'
import get from 'lodash/get'
import isString from 'lodash/isString'

export default {
  loginAttempt({ dispatch }: any, payload: any) {
    // New payload for login action
    const newPayload = {
      updateUsername: payload.updateUsername,
      userDetails: payload.userDetails,
      notify: payload.vs.notify,
      closeAnimation: payload.closeAnimation,
      acl: payload.acl
    }

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {
      // TODO Implement remember me
      dispatch('login', newPayload)
    } else {
      // Try to login
      dispatch('login', newPayload)
    }
  },
  login({ commit, state, dispatch }: any, payload: any) {
    const service: LoginService = LoginService.build(payload.notify)

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login',
        text: 'Você já está autenticado!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }

    service.post('v1/login', {
        email: payload.userDetails.email,
        password: payload.userDetails.password
      }).then(
        data => {
          if(data.app_2fa_enabled){
            dispatch('login2faAttempt', payload)
          }else{
            payload.user = data
            dispatch('loginSuccess', payload)
          }
        },
        (error: any) => {
          console.log('error', error)
          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()
          if (error && error.status === 401 && error.data === 'unverified_account') {
            payload.notify({
              time: 10000,
              title: 'Erro',
              text:
                'Esta conta ainda não foi confirmada, por favor ative-a clicando no link enviado para seu email. Caso não tenha recebido o email, clique em "Esqueceu a senha?" e informe seu email.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else {
            payload.notify({
              time: 5000,
              title: 'Erro',
              text:
                'Não foi possível realizar o login, verifique o usuário ou a senha e tente novamente!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        }
      )
  },
  login2faAttempt({ commit, state, dispatch }: any, payload: any){
    localStorage.setItem('userInfoAut', JSON.stringify(payload))

    const routeA2faValidate = '/a2fa'

    router.push(routeA2faValidate).catch(()=>{})

  },
  loginSuccess({dispatch}, payload) {
    dispatch('updateUsername', {
      user: payload.user,
      notify: payload.notify,
      isReloadRequired: true
    })

    // store.dispatch('dataAccess/setupFromLogin', payload)

    // Close animation if passed as payload
    if (payload.closeAnimation) payload.closeAnimation()

    const permissions: any = []
    if (payload.user.permissions) {
      payload.user.permissions.forEach(element => {
        permissions.push(element.name)
      })
    }

    store.commit('UPDATE_USER_INFO', payload.user)
    require('@/services/SessionTimeoutService').default.resetActivity(true)

    if (payload.user.roles && payload.user.roles.length > 0) {
      store.commit('UPDATE_DEFAULT_ACTIVE_ROLE', payload.user.roles)
    }

    if (payload.user.pingInterval) {
      Vue.prototype.devLog('loginsuccess', 'Got ping interval from user login, setting it up', payload.user.pingInterval)
      store.commit('SET_PING_INTERVAL', payload.user.pingInterval)
    }

    const slowKbpsRate = (get(payload, 'user.slow_kbps_rate', null) || get(payload, 'slow_kbps_rate', null))
    if (slowKbpsRate !== null) store.dispatch('setSlowKbpsRate', slowKbpsRate)

    if (payload.acl) {
      const userInfoStr = localStorage.getItem('userInfo')
      const userInfo = userInfoStr ? JSON.parse(userInfoStr) : []
      payload.acl.setPermissions(userInfo.permissions)
    }

    if (payload.restrictUserLogged) {
      payload.restrictUserLogged(payload.user)
    }

    // Redirect
    let redirectRoute = '/'
    const appInfoStr: any = localStorage.getItem('appInfo')
    let appInfo: any = appInfoStr ? JSON.parse(appInfoStr) : {}
    if (
      appInfo &&
      appInfo.lastUrlPath &&
      appInfo.lastUrlPath !== '/register'
    ) {
      const lastUrlRoute = router.resolve(appInfo.lastUrlPath)
      if (payload.acl && lastUrlRoute && lastUrlRoute.route.meta && payload.acl.hasAnyPermission(lastUrlRoute.route.meta.rule)) {
        redirectRoute = appInfo.lastUrlPath
      }
    }

    // if (payload.user && 'error' in payload.user && payload.user.error === 'first_access') {
    //   redirectRoute = '/first-access'
    // }

    if (payload.user && 'uncomplete_legal_entity_id' in payload.user && payload.user.uncomplete_legal_entity_id > 0) {
      redirectRoute = `/complement/${payload.user.uncomplete_legal_entity_id}`
    }

    // Reminder
    // Our vuex store must be refactored at some point in the future, the need
    // to add the following block of code in *this place* is the main sign of it.
    // Not only that, but there are mutations in the main store when they should
    // have been in auth's mutation, and the stages of the login process are kinda
    // scattered over the actions in this file.
    const notification = NotificationService.build(Vue.prototype)
    if (payload.user.unreadNotifications) {
      Vue.prototype.devLog('loginSuccess', 'On the login route, came some unread notifications, setting... ', payload.user.unreadNotifications)
      store.dispatch('resetUnreadNotifications', notification.constructManyNotifications(payload.user.unreadNotifications))
    }
    // ---------------------------------------------------------------------------

    // Busca e exibe último acesso após login bem-sucedido
    setTimeout(() => {
      const userService = UserService.build()
      userService.getLastAccess().then((data) => {
        Vue.prototype.devLog('lastAccess', 'Dados recebidos:', data)
        if (data && !data.error && !data.message) {
          // Dispara evento global para mostrar popup usando router.app
          Vue.prototype.devLog('lastAccess', 'Disparando evento showLastAccessPopup')
          if (router.app && router.app.$root) {
            router.app.$root.$emit('showLastAccessPopup', data)
          } else {
            Vue.prototype.devLog('lastAccess', 'router.app não disponível, tentando alternativa')
            // Fallback: usar window para armazenar temporariamente
            const vueAppInstance = (window as any).__vueAppInstance__
            if (vueAppInstance && vueAppInstance.$root) {
              vueAppInstance.$root.$emit('showLastAccessPopup', data)
            }
          }
        } else {
          Vue.prototype.devLog('lastAccess', 'Sem dados para exibir:', data)
        }
      }).catch((error) => {
        // Silenciosamente ignora erros (usuário sem acesso anterior, etc)
        Vue.prototype.devLog('lastAccess', 'Erro ao buscar último acesso:', error)
      })
    }, 2000) // Aguarda 2 segundos após login para garantir que tudo está carregado

    router.push(redirectRoute).catch(()=>{})
  },
  socialLogin ({dispatch, commit, state}, payload) {
    const user = payload.user
    if (user && !('authenticated' in user)) {
      const newPayload = {
        userDetails: {
          name: payload.user.name,
          email: payload.user.email,
          person_type: 'student'
        },
        vs: payload.vs,
        acl: payload.acl,
        closeAnimation: () => {
          payload.vs.loading.close()
        },
        restrictUserLogged: payload.restrictUserLogged
      }
      store.dispatch('auth/registerRestrictUser', newPayload)

    } else if ('token' in user) {
      const newPayload = {
        user: user,
        updateUsername: true,
        userDetails: {
          email: user.email,
        },
        notify: payload.vs.notify,
        closeAnimation: payload.closeAnimation,
        acl: payload.acl,
        restrictUserLogged: payload.restrictUserLogged
      }
      dispatch('loginSuccess', newPayload)
    }
  },

  logout({ commit, state, dispatch }: any, payload: any) {
    const service = LoginService.build()
    const canUseLoading = payload && payload.vs && !payload.skipLoading
    canUseLoading && payload.vs.loading()

    // Regardless if the logout route was successfull, clear localstore and loading animation.
    const finalize = () => {
      const sessionTimeoutService = require('@/services/SessionTimeoutService').default
      sessionTimeoutService.beginLogoutToLogin()
      sessionTimeoutService.clearActivity()
      if (router.app && router.app.$root) {
        router.app.$root.$emit('hideLastAccessPopup')
      }
      store.dispatch('dataAccess/resetStore')
      store.dispatch('resetUserInfo').then((finished) => {
        auth.logOut()
        canUseLoading && payload.vs.loading.close()
        if (router.currentRoute.path !== '/login') {
          router.push('/login').catch(() => {})
        }
      }, (error) => {
        if (canUseLoading) {
          payload.vs.loading.close()
          Vue.prototype.notifyError(payload.vs, 'Não foi possível limpar o estado da aplicação.')
        }
        if (router.currentRoute.path !== '/login') {
          router.push('/login').catch(() => {})
        }
      })
    }

    service.post('v1/logout', {}).then(
      data => {

        // Delete local storage lastUrlPath
        let appInfoStr: any = localStorage.getItem('appInfo')
        let appInfo: any = appInfoStr ? JSON.parse(appInfoStr) : {}
        delete appInfo.lastUrlPath
        localStorage.setItem('appInfo', JSON.stringify(appInfo))

        finalize()
      },
      (error: any) => {
        finalize()
      }
    )
  },
  changePasswordAttempt({ dispatch }: any, payload: any) {
    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation,
      acl: payload.acl
    }

    dispatch('changePassword', newPayload)
  },
  changePassword({ commit, state, dispatch }: any, payload: any) {
    const service = LoginService.build(payload.notify)

    service
      .post(`v1/password/change`, {
        password: payload.userDetails.password,
        password_confirmation: payload.userDetails.passwordConfirm
      })
      .then(
        data => {
          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()
          if (payload.notify) {
            payload.notify({
              time: 5000,
              title: 'Sucesso',
              text: 'Senha alterada com sucesso!',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            })
          }
          const permissions: any = []
          if (data.permissions) {
            data.permissions.forEach(element => {
              permissions.push(element.name)
            })
          }
          if (data.people && data.people.length > 0) {
            store.commit('UPDATE_ACTIVE_PERSON', data.people[0])
          }

          store.dispatch('updateUserInfo', {permissions: data.permissions, roles: data.roles})

          payload.acl.setPermissions(data.permissions)

          // router.push('/').then(() => {
          //   if (data.roles && data.roles.length > 0) {
          //     store.commit('UPDATE_DEFAULT_ACTIVE_ROLE', data.roles)
          //   }
          // })
        },
        (error: any) => {
          if (payload.closeAnimation) payload.closeAnimation()
          if ('data' in error && isString(error.data)) {
            const data = JSON.parse(error.data)
            const message = get(data, 'errors.password.0')
            if (message) {
              payload.notify({
                time: 10000,
                title: 'Atenção',
                text: message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
              })
            }
          }

          payload.notify({
            time: 5000,
            title: 'Erro',
            text: 'Não foi possível alterar a senha!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      )
  },
  resetPassword({ commit, state, dispatch }: any, payload: any) {
    const service = LoginService.build(payload.vs)

    service
      .post('v1/password/reset', {
        token: payload.userDetails.token,
        email: payload.userDetails.email,
        password: payload.userDetails.password,
        password_confirmation: payload.userDetails.passwordConfirm
      })
      .then(
        data => {
          if (payload.closeAnimation) payload.closeAnimation()
          router.push('/login')

          payload.vs.notify({
            time: 5000,
            title: 'Sucesso',
            text: 'Senha alterada com sucesso!',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
        },
        (error: any) => {
          if (payload.closeAnimation) payload.closeAnimation()
        }
      )
  },
  forgotPassword({ commit, state, dispatch }: any, payload: any) {
    const service = LoginService.build(payload.notify)

    service
      .post('v1/password/email', {
        email: payload.email
      })
      .then(
        data => {
          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time: 20000,
            title: 'Sucesso!',
            text: data.success,
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
        },
        (error: any) => {
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time: 5000,
            title: 'Erro',
            text:
              'Houve um problema ao realizar sua operação, tente novamente!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      )
  },

  registerUser({ dispatch }: any, payload: any) {
    const service = UserService.build(payload.vs)

    service.post(payload.userDetails.social ? `store_social` : 'store', payload.userDetails).then(
      user => {
        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        let message = 'Usuário criado com sucesso.'
        if (!payload.userDetails.social) {
          message = `${message} Um email foi enviado para ativar sua conta!`
        }

        payload.vs.notify({
          time: 10000,
          title: message,
          text: user.success,
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success'
        })

        if (payload.userDetails.social) {
          const newPayload = {
            user: user,
            updateUsername: true,
            userDetails: {
              email: user.email,
              password: payload.userDetails.password
            },
            notify: payload.notify,
            closeAnimation: payload.closeAnimation
          }
          dispatch('login', newPayload)
        } else {
          router.push('login')
        }

      },
      (error: any) => {
        if (payload.closeAnimation) payload.closeAnimation()
        if (payload.showErrors) payload.showErrors(error)

      }
    )
  },

  updateUsername({ commit }: any, payload: any) {
    const newUserData = Object.assign({}, payload.user)
    //commit('UPDATE_AUTHENTICATED_USER', newUserData)

    store.commit('UPDATE_USER_INFO', {
      displayName: newUserData.name
    })

    // If reload is required to get fresh data after update
    // Reload current page
    // if (payload.isReloadRequired) {
    //   router.push(router.currentRoute.query.to.toString() || '/')
    // }
  },
  updateAuthenticatedUser({ commit }: any, payload: any) {
    //commit('UPDATE_AUTHENTICATED_USER', payload)
    store.commit('UPDATE_USER_INFO', payload.user)
  }
}
